import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    props: { showFullUI: false } // Halaman utama: simplified
  },
  {
    path: '/backup',
    name: 'HomeBackup',
    component: () => import('@/views/Home.vue'),
    props: { showFullUI: true } // Halaman backup: full UI
  },
  {
    path: '/scan',
    name: 'TicketScanner',
    component: () => import('@/views/TicketScanner.vue')
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('@/views/AdminDashboard.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
